/* eslint-disable import/no-mutable-exports */
/* eslint-disable global-require */
import FilesUploader from './FilesUploader/FilesUploader';
import DirectFilesUploaderCoordinator from './DirectFilesUploaderCoordinator';

let directFilesUploader;
let directFilesUploaderSubscriber;
let filesUploader;

const initializeDirectFilesUploader = ( store ) => {
	// Lazy require to break circular dependency:
	// assetUploads.js -> directFilesUploaderInitializer.js -> DirectFileUploaderStoreSubscriber.js -> assetUploads.js
	const DirectFileUploaderStoreSubscriber = require( './DirectFileUploaderStoreSubscriber' ).default;

	directFilesUploader = new DirectFilesUploaderCoordinator();
	directFilesUploaderSubscriber = new DirectFileUploaderStoreSubscriber(
		directFilesUploader,
		store
	);
	directFilesUploaderSubscriber.start();
	filesUploader = new FilesUploader();
};

export { directFilesUploader, directFilesUploaderSubscriber, filesUploader };
export default initializeDirectFilesUploader;
